import axiosInstance from "@/api/axiosInstance";

export class PasswordResetService {
  /**
   * Resolves for any accepted request, even when the address is unknown or the account is still
   * inside its resend cooldown — the backend deliberately does not reveal which addresses are
   * registered. Rejects with 429 when the caller's IP has made too many requests.
   */
  public async requestReset(email: string): Promise<void> {
    await axiosInstance.post("/api/v1/password-reset/request", { email });
  }

  public async validateToken(token: string): Promise<void> {
    await axiosInstance.get("/api/v1/password-reset/validate", {
      params: { token },
    });
  }

  public async confirmReset(
    token: string,
    password: string
  ): Promise<{ role: string }> {
    const response = await axiosInstance.post(
      "/api/v1/password-reset/confirm",
      { token, password }
    );
    return response.data;
  }
}
